export * from './replace.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/replace/index.ts